import React from 'react'
import { SearchType } from './hooks/useMobileSearchAPI'
import { MobileSearchTypeDropdown } from './MobileSearchTypeDropdown'

interface MobileSearchDropdownProps {
  value: SearchType
  label: string
  onChange: (value: SearchType) => void
}

export const MobileSearchDropdown: React.FC<MobileSearchDropdownProps> = ({
  value,
  label,
  onChange,
}) => {
  return (
    <MobileSearchTypeDropdown
      value={value}
      label={label}
      onChange={onChange}
      labelPrefix="Search for a"
    />
  )
}
